const TestFooter = ({ footer }) => {
  const signatories = [
    { name: footer?.labTechnician || "Ahmad Saeed", title: "Lab Tech" },
    { name: "Dr. Tariq Dahri", title: "M.B.B.S (Pak), RMP" },
    { name: "Dr. Bushra Tahreem", title: "M.B.B.S (Pb), DCP Pathology" },
  ];

  return (
    <div className="pdf-footer" style={{ marginTop: "40px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        {signatories.map((s, i) => (
          <div key={i} style={{ textAlign: "center", minWidth: "180px" }}>
            <strong>{s.name}</strong>
            <div
              style={{
                borderTop: "1px solid #000",
                width: "150px",
                margin: "5px auto",
              }}
            ></div>
            <small>{s.title}</small>
          </div>
        ))}
      </div>
      <hr style={{ margin: "15px 0 5px" }} />
      <p
        style={{
          textAlign: "center",
          fontSize: "11px",
          color: "#6c757d",
          margin: 0,
        }}
      >
        Computer generated report. No need for signature.
      </p>
    </div>
  );
};

export default TestFooter;
